<app-page-body>
  <!-- header -->
  <app-page-header
    [title]="title"
    [isForm]="true"
    [loading]="loading"
    (onBack)="onClose()"
    (onRefresh)="onReset()"
  >
  </app-page-header>

  <!-- content -->
  <div class="app-page-content">
    <!-- form -->
    <form [formGroup]="form" autocomplete="off">
      <div class="row">
        <div class="2xl:tw-w-1/2 tw-w-full">
          <fieldset class="tw-h-full">
            <legend>
              {{ "common.text" | translate }}
            </legend>

            <div class="row tw-flex tw-flex-col p-3 tw-sticky tw-top-[110px]">
              <!--* contentText  -->
              <div class="tw-w-full">
                <app-ngx-editor [control]="form.get('contentText')">
                </app-ngx-editor>
              </div>
            </div>
          </fieldset>
        </div>
        <div class="2xl:tw-w-1/2 tw-w-full">
          <fieldset>
            <legend>
              {{ "common.setting" | translate }}
            </legend>

            <div class="row">
              <div class="tw-w-full">
                <app-periodic-date-picker
                  class="row"
                  [config]="periodicDateConfig"
                  (startDate)="model.startDate = $event"
                  (endDate)="model.endDate = $event"
                >
                </app-periodic-date-picker>
              </div>

              <!-- title -->
              <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-2/4">
                <form-field
                  [(value)]="model.title"
                  [control]="form?.get('title')"
                  label="common.title"
                >
                </form-field>
              </div>

              <!-- customerDomainId -->
              <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-2/4">
                <customer-domain-select-search
                  [control]="form?.get('customerDomainId')"
                  [label]="fields + 'customerDomainName'"
                  [(value)]="model.customerDomainId"
                  (onError)="onClose()"
                >
                </customer-domain-select-search>
              </div>

              <!-- isActive -->
              <div class="tw-py-2 tw-flex tw-items-center">
                <mat-slide-toggle
                  formControlName="isActive"
                  [(ngModel)]="model.isActive"
                >
                  {{ "common.isActive" | translate }}
                </mat-slide-toggle>
              </div>

              <!-- isRequiredToSeen -->
              <div class="tw-py-2 tw-flex tw-items-center">
                <mat-slide-toggle
                  formControlName="isRequiredToSeen"
                  [(ngModel)]="model.isRequiredToSeen"
                >
                  {{ fields + "isRequiredToSeen" | translate }}
                </mat-slide-toggle>
              </div>

              <!-- isActive displayForAllSubOrganizationsSend -->
              <div class="tw-py-2 tw-flex tw-items-center">
                <mat-slide-toggle
                  formControlName="displayForAllSubOrganizations"
                  [(ngModel)]="model.displayForAllSubOrganizations"
                >
                  <app-expand-text [placement]="'right'">
                    <span small-text>
                      {{
                        fields + "displayForAllSubOrganizations" | translate
                      }}</span
                    >
                    <div full-text class="full-text-display">
                      {{ fields + "displayForAllSubOrganizations" | translate }}
                    </div>
                  </app-expand-text>
                </mat-slide-toggle>
              </div>
            </div>
          </fieldset>
          <fieldset class="tw-mt-4">
            <legend>
              {{ "common.organizations" | translate }}
            </legend>

            <div class="tw-w-full">
              <organization-selection-list
                type="descendantList"
                searchLabel="messages.searchInOrganizations"
                [values]="model.organizationIdListForShow"
                (values)="model.organizationIdListForShow = $event"
                searchBoxGridClass="sm:tw-w-1/2 xl:tw-w-2/3"
                responsiveClass="sm:tw-w-1/2 xl:tw-w-1/3"
              >
              </organization-selection-list>
            </div>
          </fieldset>
        </div>
      </div>

      <!-- form btns-->
      <app-form-btns
        [loading]="loading"
        [form]="form"
        [isEdit]="formPageConfig.isEditMode"
        (onClose)="onClose()"
        (onSubmit)="onSubmit()"
      >
      </app-form-btns>
    </form>
  </div>
</app-page-body>
